import React, { JSX } from 'react';
import { FaIcon, FaIconProps } from './FaIconReplica';
import { merge } from '../../helpers/classes';

export type IconProps = FaIconProps & {
  cn?: string;
};

export const Icon = (props: IconProps): JSX.Element => {
  const { cn, className, ...rest } = props;

  return <FaIcon className={merge(cn, className)} {...rest} />;
};
